import React, { useEffect, useState } from "react";

const AnalyticsRFQINQ: React.FC = () => {
  useEffect(() => {
    (window as any).Highcharts.chart("c1", {
      chart: {
        type: "line",
      },
      title: {
        text: "RFQs and Inquiries",
      },
      subtitle: {
        text: "Buyer: Tatenda Sibanda",
      },
      xAxis: {
        categories: [
          "Jan 24",
          "Feb 24",
          "Mar 24",
          "Apr 24",
          "May 24",
          "Jun 24",
          "Jul 24",
          "Aug 24",
          "Sep 24",
          "Oct 24",
          "Nov 24",
          "Dec 24",
        ],
        accessibility: {
          description: "Months of the year",
        },
      },
      yAxis: {
        title: {
          text: "Volume",
        },
        labels: {
          format: "{value}",
        },
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      plotOptions: {
        line: {
          marker: {
            radius: 1,
            lineColor: "#666666",
            lineWidth: 1,
          },
        },
      },
      series: [
        {
          name: "RFQs",
          marker: {
            symbol: "circle",
          },
          data: [45, 64, 72, 68, 70, 76, 96, 80, 71, 65, 68, 71],
        },
        {
          name: "Inquiries",
          marker: {
            symbol: "circle",
          },
          data: [38, 52, 55, 60, 63, 56, 75, 70, 66, 58, 49, 65],
        },
      ],
    });
  }, []);

  return (
    <>
      <div className="card mb-5">
        <div className="collapse show">
          <div id="kt_account_signin_method" className="collapse show">
            <div className="card-body border-top p-9">
              <div className="col-md-12 c1" id="c1">
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { AnalyticsRFQINQ };
